import { logError } from "Logger";
import { SPThunkAction } from "common/ReduxUtils";
import { selectTransferCreate } from "transfers/create/store/TransferCreateSelectors";
import { resetPackingOptionsState } from "../packingOptions/actions/PackingOptionsActions";
import { replenishmentClient } from "Clients";
import { transferCreateResetReplenishmentOrder } from "transfers/create/actions";
import { resetPlacementOptionsState } from "../placementOptions/actions/PlacementOptionsActions";

export const archiveAndResetFbaV3Order = (): SPThunkAction => async (dispatch, getState) => {
  const { replenishmentOrder } = selectTransferCreate(getState());
  const orderId = replenishmentOrder!.orderId;

  dispatch(resetPackingOptionsState());
  dispatch(resetPlacementOptionsState());
  dispatch(transferCreateResetReplenishmentOrder());

  try {
    await replenishmentClient.archiveOrder(orderId);
  } catch (err) {
    logError({ fn: "archiveAndResetFbaV3Order", orderId }, err, "Error archiving FBA V3 order");
  }
};
